import { CSSProperties } from "react";
import { Popover } from "antd";
import type { PopoverProps } from "antd";

export type UIPopoverProps = PopoverProps & {
  sx?: Record<string, unknown>;
};

export const UIPopover = ({ sx, overlayStyle, ...props }: UIPopoverProps) => {
  const sxStyle = (sx ?? {}) as CSSProperties;

  return <Popover overlayStyle={{ ...sxStyle, ...(overlayStyle as CSSProperties) }} {...props} />;
};
